const RECHARGE_GIFT_POPUP_STORAGE_PREFIX = 'recharge-gift-popup:';
let hasShownInCurrentPageLifecycle = false;

const getRechargeGiftPopupStorageKey = () => {
  const date = new Date();
  const dateKey = `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()}`;
  return `${RECHARGE_GIFT_POPUP_STORAGE_PREFIX}${dateKey}`;
};

export const canShowRechargeGiftPopup = (dailyPopupLimit?: number | null) => {
  // 与普通弹窗未配置 dailyImpressions 的行为保持一致：当前页面生命周期
  // 只展示一次，强制刷新页面后可再次展示。
  if (dailyPopupLimit === 0) {
    return !hasShownInCurrentPageLifecycle;
  }
  const popupCount = Number(
    localStorage.getItem(getRechargeGiftPopupStorageKey()) || 0,
  );
  return popupCount < Math.max(0, dailyPopupLimit ?? 1);
};

export const markRechargeGiftPopupShown = (dailyPopupLimit?: number | null) => {
  hasShownInCurrentPageLifecycle = true;
  if (dailyPopupLimit === 0) {
    return;
  }
  const storageKey = getRechargeGiftPopupStorageKey();
  const popupCount = Number(localStorage.getItem(storageKey) || 0);
  localStorage.setItem(storageKey, String(popupCount + 1));
};

export const clearRechargeGiftPopupCount = () => {
  hasShownInCurrentPageLifecycle = false;
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(RECHARGE_GIFT_POPUP_STORAGE_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
};
